import { CanMatchFn, Routes } from '@angular/router';
import { environment } from '../../../environments/environment';

/**
 * The catalog is only reachable while `environment.publicCatalog` is on. The
 * flag is the kill switch: with it off these URLs fall through to the wildcard
 * "page not found" route, so a build can ship the code without exposing the
 * guest experience.
 *
 * English is unprefixed, so the English catalog route is declared last in
 * app.routes.ts — after every application route — and matches only what is
 * left over. Arabic sits under /ar.
 */
export const catalogEnabled: CanMatchFn = () => environment.publicCatalog === true;

/**
 * Guest browsing — no guards: every page shows approved public data only
 * (enforced by the /api/public backend). Customer-only actions inside these
 * pages go through AuthIntentService.
 */
export const PUBLIC_CATALOG_ROUTES: Routes = [
  // The entry page: every eligible provider, with the categories as filters.
  // Reuses the listing component — with no :category param it lists everything.
  {
    path: '',
    pathMatch: 'full',
    loadComponent: () =>
      import('./pages/provider-listing-page.component').then((m) => m.ProviderListingPageComponent),
  },
  // The freelancers tab. Same component as the catalog with the audience fixed
  // by route data, so the page is a real URL that can be prerendered, linked
  // and canonicalised — the catalog above is the companies tab.
  {
    path: 'freelancers',
    data: { type: 'influencer' },
    loadComponent: () =>
      import('./pages/provider-listing-page.component').then((m) => m.ProviderListingPageComponent),
  },
  // Retired public pages: the services index and the standalone category and
  // category/city pages. A category is now a filter on the listing itself
  // (/?category=<slug>), so these URLs fall through to "page not found". The
  // components are kept; restore by uncommenting.
  // {
  //   path: 'services',
  //   loadComponent: () => import('./pages/services-page.component').then((m) => m.ServicesPageComponent),
  // },
  // {
  //   path: 'services/:category',
  //   loadComponent: () => import('./pages/provider-listing-page.component').then((m) => m.ProviderListingPageComponent),
  // },
  // {
  //   path: 'services/:category/:city',
  //   loadComponent: () => import('./pages/provider-listing-page.component').then((m) => m.ProviderListingPageComponent),
  // },
  {
    path: 'search',
    data: { search: true },
    loadComponent: () => import('./pages/provider-listing-page.component').then((m) => m.ProviderListingPageComponent),
  },
  {
    path: 'providers/:id',
    loadComponent: () => import('./pages/public-provider-page.component').then((m) => m.PublicProviderPageComponent),
  },
  {
    path: 'providers/:id/:slug',
    loadComponent: () => import('./pages/public-provider-page.component').then((m) => m.PublicProviderPageComponent),
  },
];
